// extracted by mini-css-extract-plugin
module.exports = {"power-independence-L":"L_power-independence-L__g4goG"};